import {AddressSummaryApiDto} from "../../api/model/rest";

/**
 * Address summary model.
 */
export default class AddressSummary {

	/**
	 * @param id id of the address.
	 * @param text text to display.
	 * @param description description.
	 */
	constructor(public readonly id: string,
		public readonly text: string,
		public readonly description: string) {}

	static fromJson(json: AddressSummaryApiDto) {
		return new AddressSummary(json.id, json.text, json.description)
	}
}